import React, { PureComponent } from 'react';
import schemify from 'url-schemify';
import Autolinker from 'autolinker';
import { withTranslation } from 'react-i18next';
import { Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
import handleViewport from 'react-in-viewport';

import FieldDefault from '../field-default';

import BodyPortal from '../../portals/body-portal';

import IconClose from '../../icons/icon-close';
import IconLink from '../../icons/icon-link';
import IconBrokenLink from '../../icons/icon-broken-link';

class DocLink extends PureComponent {
    state = {
        inputVisible: false
    }

    handleClick = event => {
        if (!this.href) {
            return;
        }

        if (this.props.onClick) {
            event.preventDefault();
            this.props.onClick(schemify(this.href));

            return;
        }

        window.open(schemify(this.href), '_blank');
    }

    handleFieldBlur = href => {
        const { element, onRemove } = this.props;

        if (!href && element.children.length === 1 && element.children[0].text === 'link') {
            onRemove && onRemove(element);
            return;
        }

        this.setHref(href);

        requestAnimationFrame(() => {
            this.setState({
                inputVisible: false
            });
        });
    }

    handleLinkRemove = () => {
        const { element, editor } = this.props;
        const path = ReactEditor.findPath(editor, element);

        Transforms.unwrapNodes(editor, {
            at: path,
            match: node => {
                return node === element;
            }
        });
    }

    handleDocInputTrigger = () => {
        this.setState({
            inputVisible: true
        });
    }

    setHref(href) {
        const { element, onNodeChange } = this.props;

        onNodeChange && onNodeChange(element, element.type, { href });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.inputVisible && this.linkElement && this.inputElement) {
            const rect = this.linkElement.getBoundingClientRect();

            this.inputElement.style.top = `${rect.top}px`;
            this.inputElement.style.left = `${rect.left + rect.width / 2}px`;
        }

        if (this.state.inputVisible && !prevState.inputVisible && this.inputCtrl) {
            setTimeout(() => {
                this.inputCtrl && this.inputCtrl.focus();
            }, 10);
        }
    }

    componentDidMount() {
        if (!this.href && this.linkElement.textContent) {
            const matches = Autolinker.parse(this.linkElement.textContent);
            if (matches.length) {
                this.setHref(schemify(this.linkElement.textContent));
                return;
            }
        }

        setTimeout(() => {
            if (this.props.inViewport) {
                this.setState({
                    inputVisible: !this.href
                });
            }
        }, 200);
    }

    get href() {
        return this.props.href || '';
    }

    setLinkElement = element => this.linkElement = element;
    setInputElement = element => this.inputElement = element;

    render() {
        const { readOnly, attributes, children, t } = this.props;

        return (
            <span className="doc-link" ref={this.setLinkElement}>
                {
                    !readOnly && this.state.inputVisible ? (
                        <BodyPortal>
                            <div className="doc-link-input" contentEditable={false} ref={this.setInputElement}>
                                <FieldDefault ref={ctrl => this.inputCtrl = ctrl} placeholder={ t('Enter link') } small={true} blurOnEnter={true} value={this.href} autoFocus={true} onBlur={this.handleFieldBlur} />

                                <span className="doc-link-action" onMouseDown={this.handleLinkRemove}>
                                    <IconBrokenLink />
                                </span>

                                <span className="doc-link-action">
                                    <IconClose />
                                </span>
                            </div>
                        </BodyPortal>   
                    ) : null
                }

                <a {...attributes} target="_blank" rel="noopener noreferrer" onClick={this.handleClick} href={schemify(this.href)}>{children}</a>

                {
                    !readOnly ? (
                        <span className="doc-input-trigger" onClick={this.handleDocInputTrigger}>
                            <IconLink />
                        </span>
                    ) : null
                }
            </span>
        )
    }
}

export default withTranslation('doc')(handleViewport(DocLink));
